import React, { useEffect, useState } from "react";
import UpcomingTrips from "../../components/BusinessTripComponents/UpcomingTrips";
import BizTripHomePassengerDetails from "../../components/BusinessTripComponents/BizTripHomePassengerDetails";
import BizTripTypes from "../../components/BusinessTripComponents/BizTripTypes";
import { useDestinationContext } from "../../contexts/DestinationContext";
import { getFormattedDestinationSelectfieldData } from "../../helper";
import { airports } from "../../config/airports";
import SubmitBizTripRequestButton from "../../components/BusinessTripComponents/SubmitBizTripRequestButton";
import {
  // CAR_TYPE,
  FLIGHT_TYPE,
  FORM_ERROR_INITIALIZATION,
  // HOTEL_TYPE,
  INITIALIZE_BIZ_TRIP_FORM,
  PAYMENT_TYPE,
  TRAVEL_TYPE,
} from "../../constants";
import BizTripForm from "../../components/BusinessTripComponents/BizTripForm";
import dayjs from "dayjs";
import { useBizTripBookingContext } from "../../contexts/BizTripBookingContext";
import ConfirmBookingDialog from "../../components/BusinessTripComponents/ConfirmBooking";
import {
  BookingContainer,
  Container,
  DetailsContainer,
  LeftSection,
  RightSection,
  Title,
} from "./StyledBusinessTripHome";
import {
  addBizBooking,
  getUpcomingTrip,
  updateBizBooking,
  uploadLeaveAttachment,
} from "../../services/bizBookingService";
import toast from "react-hot-toast";
import { fetchUserData, getUsersPassport } from "../../services/userServices";
import {
  getBizTripPayload,
  validateBizTrip,
  validateLeaveRequest,
  validateLeaveWithData,
  validateMixDomesticInternational,
  validatePerdiem,
} from "./helper";
import { useLoaderContext } from "../../contexts/loaderContext";
import LeaveForm from "../../components/BusinessTripComponents/LeaveForm";
import {
  empBookingId,
  getApproversList,
  getCompanyList,
  getCostCenter,
  getDropdownsForReason,
  getLeaveDetails,
  getPerdiemData,
  getProjectId,
  uploadDocuments,
} from "../../services/bookingServices";
import UpcomingLeaves from "../../components/BusinessTripComponents/UpcomingLeaves";
import SuccessBookingDialog from "../../components/BusinessTripComponents/SuccessBookingDialog";
import { useNavigate, useParams } from "react-router-dom";
import { useProfileContext } from "../../contexts/ProfileContext";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import { Colors } from "../../config";
import styled from "styled-components";
import ConfirmPopup from "../../components/BusinessTripComponents/SameTimeConfirmationModal";
import ErrorModal from "../../components/ErrorSuccessModal/ErrorModal";

const BusinessTripHome = () => {
  let { id } = useParams();
  const { setDestinations } = useDestinationContext();
  const [bookingId, setBookingId] = useState("");
  const {
    bizData,
    setBizData,
    setActiveTripType,
    activeTripType,
    setUserData,
  } = useBizTripBookingContext();
  const navigate = useNavigate();

  const { loading, setLoader } = useLoaderContext();
  const [profileData, setProfileData] = useState({});
  const { profile, setProfile } = useProfileContext();
  const [passportData, setPassportData] = useState();
  const [errors, setErrors] = useState([...FORM_ERROR_INITIALIZATION]);
  const [activeMCIndex, setActiveMCIndex] = useState(0);
  const [loader, setLoading] = useState(false);
  const [settingsData, setSettingsData] = useState([]);
  const [isValidForm, setValidFrom] = useState(false);
  const [applyLeaveData, setApplyLeave] = useState({
    startDate: "",
    endDate: "",
    comments: "",
    attachmentId: "",
    attachmentUrl: "",
  });
  const [perDiemData, setPerDiemData] = useState({});
  const [errorModal, setErrorModal] = useState({
    open: false,
    title: "",
    message: "",
  });

  const [applyLeaveFormErrors, setApplyLeaveErrors] = useState({
    startDate: "",
    endDate: "",
    comments: "",
    attachmentId: "",
    attachmentUrl: "",
  });
  const [upcomingLeaves, setUpcomingLeaves] = useState([]);
  const [upcomingTrips, setUpcomingTrips] = useState([]);
  const [timeModal, setTimeModal] = useState(false);
  const [perDiemPopup, setPerDiemPopup] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [costCenterList, setCostCenterList] = useState([]);
  const [projectList, setProjects] = useState([]);
  const [approversList, setApproversList] = useState([]);
  const [comment, setComment] = useState("");
  const [privilegeCard, setPrivilegeCard] = useState("");
  const [leaveFile, setLeaveFile] = useState("");
  const [perDiemTripType, setPDTripType] = useState("");

  useEffect(() => {
    setDestinations(
      getFormattedDestinationSelectfieldData(airports, "name", "iata_code"),
    );
  }, []);

  useEffect(() => {
    if (!profile?.personId && !id) return;
    fetchData();
  }, [profile?.personId, id]);

  useEffect(() => {
    return () => {
      setActiveTripType("One Way");
    };
  }, []);

  const fetchData = async () => {
    setLoader(true);
    let bookingRes;
    try {
      if (id) {
        bookingRes = await empBookingId(id);
      }

      let [response, settings, tripDetails, companyList, profileResponse] =
        await Promise.all([
          getUsersPassport(),
          getDropdownsForReason(),
          getUpcomingTrip(),
          getCompanyList(),
          profile?.personId ? Promise.resolve() : fetchUserData(),
        ]);
      // fetchUserData(),
      let data;
      if (profile?.personId) {
        data = { data: { ...profile }, code: "" };
      } else {
        data = profileResponse?.data;
      }

      if (
        !data?.data?.enableBusinessTrip ||
        settings?.data?.data?.business_trip_restricted_company?.includes(
          profile?.countryOfCompany,
        )
      ) {
        navigate(`/user/dashboard`);
      }

      let leaveDetails = await getLeaveDetails({
        workTerritoryName: data?.data?.countryOfCompany,
        departmentCode: data?.data?.departmentCode,
        // endDate: dayjs().format("YYYY-MM-DD"),
        approvalStatus: "PENDING",
      });
      let updatedList = companyList?.data?.data.map((cl) => ({
        name: cl.CompanyName,
        id: cl.CompanyCode,
      }));

      if (!id) {
        let res = await getCostCenter(data?.data?.companyCode);
        let costCenterList = res?.data?.data.map((cl) => ({
          name: cl.description,
          id: cl.profit_center,
        }));
        setCostCenterList(costCenterList);
      }
      setCompanyList(updatedList);
      setUpcomingTrips(tripDetails?.data?.data);
      setUpcomingLeaves(leaveDetails?.data?.data || []);
      setSettingsData(settings?.data?.data?.business_trip_requests || {});
      setPassportData(response?.data?.data);
      setProfileData({ ...data?.data });
      setProfile({ ...data?.data });
      setUserData(data?.data);
      if (id) {
        let editObj = bookingRes?.data?.data;
        setPrivilegeCard(editObj?.membersInfo[0]?.privilegeClub || "");
        setLeaveFile(editObj?.leaveId?.attachmentUrl || "");
        let res = await getCostCenter(
          editObj?.travelDetails[0]?.costBorneBy?.companyCode,
        );
        let costCenterList = res?.data?.data.map((cl) => ({
          name: cl.description,
          id: cl.profit_center,
        }));
        let projectres = await getProjectId(
          editObj?.travelDetails[0]?.costCenter,
        );
        let projectList = projectres?.data?.data.map((pl) => ({
          name: `${pl.Project_Definition}`,
          id: pl.Project_Definition,
        }));
        console.log(editObj);

        setComment(editObj?.bookingComments);
        fetchPerDiemData(
          editObj?.leaveId?.startDate,
          editObj?.leaveId?.expectedReturnDate,
          { ...data?.data },
          false,
        );

        setProjects(projectList);
        setCostCenterList(costCenterList);
        setActiveTripType(
          editObj?.businessTripType === "multiCity"
            ? "Multi City"
            : editObj?.businessTripType === "oneWay"
              ? "One Way"
              : "Round Trip",
        );
        setApplyLeave({
          startDate: editObj?.leaveId?.startDate,
          endDate: editObj?.leaveId?.expectedReturnDate,
          comments: editObj?.leaveId?.comment,
          attachmentId: editObj?.leaveId?.attachmentId,
          attachmentUrl: editObj?.leaveId?.attachmentUrl,
        });

        let initialEditData = editObj?.travelDetails?.map((details) => {
          // console.log(getbusinessReqObjEditflow(settings?.data?.data?.business_trip_requests,details?.businessTripReqs));
          return {
            type: details?.returnJourney ? "Round Trip" : "One Way",
            from: details?.from,
            to: details?.to,
            departureDate: details?.departureDate,
            departureTime: details?.departureTime,
            returnDate: details?.returnDate,
            returnTime: details?.returnTime,
            costBorneBy: details?.costBorneBy?.companyCode,
            projectId: details?.projectId,
            costCenter: details?.costCenter,
            flightType:
              details?.flightType === "directFlight"
                ? "Direct Flight"
                : "Indirect Flight",
            paymentType:
              details?.paymentType === "company paid"
                ? "Company Paid"
                : "Self Paid",
            travelClass: details?.travelType,
            preferredAirlines: INITIALIZE_BIZ_TRIP_FORM.preferredAirlines.map(
              (airline) => {
                return {
                  label: airline.label,
                  selected: details?.perferAirline?.includes(airline.label),
                };
              },
            ),
            businessRequirement:
              getbusinessReqObjEditflow(
                settings?.data?.data?.business_trip_requests,
                details?.businessTripReqs,
                data?.data,
              ) || {},
          };
        });
        // console.log(initialEditData);

        setBizData(initialEditData);
        setErrors(
          Array.from({ length: initialEditData?.length }, () => ({
            ...FORM_ERROR_INITIALIZATION[0],
          })),
        );
      } else {
        setBizData([
          {
            ...INITIALIZE_BIZ_TRIP_FORM,
            costBorneBy: data?.data?.companyCode,
            costCenter: data?.data?.jobInfoNavCostCode,
            travelClass:
              data?.data?.customString15 === "1139"
                ? "Business Class"
                : Number(data?.data?.grade.split("-")[1]) >= 23
                  ? "Business Class"
                  : "Economy",
            preferredAirlines: INITIALIZE_BIZ_TRIP_FORM.preferredAirlines.map(
              (airline) => {
                return {
                  label: airline.label,
                  selected: false,
                };
              },
            ),
            businessRequirement:
              getbusinessReqObj(
                settings?.data?.data?.business_trip_requests,
                data?.data,
              ) || {},
          },
        ]);
      }
    } catch (err) {
      // toast.error(err?.message);
      setErrorModal({
        open: true,
        message: err?.message,
        title: "Oops!",
      });
    } finally {
      setLoader(false);
    }
  };

  const getbusinessReqObj = (settings, userData) => {
    return settings.map((item) => {
      const req = {
        name: item.value,
        label: item.key,
        isChecked: false,
        hasMultipleSelection: item?.hasMultipleSelection,
      };
      if (item.dropdown || item.key === "per_diem") {
        req.selected = "";
        if (item.key === "hotel_accommodation") {
          let grade = userData?.grade.split("-")[1];
          if (grade > 20) {
            req.dropdown = item.dropdown;
          } else {
            let dropdownItemsClone = [...item.dropdown];
            req.dropdown = dropdownItemsClone.filter(
              (item) => item !== "5 Star Hotel",
            );
          }
        } else {
          req.dropdown = item.dropdown;
        }
      }
      return req;
    });
  };

  const getbusinessReqObjEditflow = (settings, data, userData) => {
    return settings.map((item) => {
      // Match `item.key` with `data.label`
      const currentItem = data.find((ci) => ci.label === item.key);

      // console.log("currentItem:", JSON.parse(JSON.stringify(currentItem)));

      const req = {
        name: currentItem?.name,
        label: currentItem?.label,
        isChecked: currentItem?.isChecked,
        hasMultipleSelection: item?.hasMultipleSelection,
      };

      if (item.dropdown || item.key === "per_diem") {
        if (item?.hasMultipleSelection) {
          req.selected =
            currentItem?.selectedArray?.length > 0
              ? currentItem?.selectedArray
              : currentItem?.selected
                ? [currentItem?.selected]
                : [];
        } else {
          req.selected = currentItem?.selected || currentItem?.amount;
        }
        if (item.key === "hotel_accommodation") {
          let grade = userData?.grade.split("-")[1];
          if (grade > 20) {
            req.dropdown = item.dropdown;
          } else {
            let dropdownItemsClone = [...item.dropdown];
            req.dropdown = dropdownItemsClone.filter(
              (item) => item !== "5 Star Hotel",
            );
          }
        } else {
          req.dropdown = item.dropdown;
        }
      }

      return req;
    });
  };

  const handleTravelTypeChange = (e) => {
    setPDTripType("");

    let startDate = "";
    let endDate = "";
    setActiveTripType(e.target.value);
    if (e.target.value === "Multi City") {
      setErrors([...FORM_ERROR_INITIALIZATION]);
      setBizData((prevBizData) => [
        {
          // ...INITIALIZE_BIZ_TRIP_FORM,
          ...prevBizData?.[0],
          departureDate: startDate,
          returnDate: endDate,
          costBorneBy:
            prevBizData?.[0]?.companyCode || profileData?.companyCode,
          costCenter:
            prevBizData?.[0]?.costCenter || profileData?.jobInfoNavCostCode,
          projectId: prevBizData?.[0]?.projectId || "",
          travelClass:
            prevBizData?.[0]?.travelClass ||
            (profileData?.customString15 === "1139"
              ? "Business Class"
              : Number(profileData?.grade?.split("-")[1]) >= 23
                ? "Business Class"
                : "Economy"),
          businessRequirement:
            getbusinessReqObj(settingsData, profileData) || {},
        },
      ]);
    } else {
      setBizData((prevBizData) => [
        {
          // ...INITIALIZE_BIZ_TRIP_FORM,
          ...prevBizData?.[0],
          type: e.target.value,
          departureDate: startDate,
          returnDate: endDate,
          costBorneBy:
            prevBizData?.[0]?.companyCode || profileData?.companyCode,
          costCenter:
            prevBizData?.[0]?.costCenter || profileData?.jobInfoNavCostCode,
          projectId: prevBizData?.[0]?.projectId || "",
          travelClass:
            prevBizData?.[0]?.travelClass ||
            (profileData?.customString15 === "1139"
              ? "Business Class"
              : Number(profileData?.grade?.split("-")[1]) >= 23
                ? "Business Class"
                : "Economy"),
          businessRequirement:
            getbusinessReqObj(settingsData, profileData) || {},
        },
      ]);
    }
  };

  const handleAddCity = () => {
    setBizData([
      ...bizData,
      {
        ...JSON.parse(JSON.stringify(INITIALIZE_BIZ_TRIP_FORM)),
        travelClass: bizData[0]?.travelClass,
        costBorneBy: bizData[0]?.costBorneBy,
        projectId: bizData[0]?.projectId,
        costCenter: bizData[0]?.costCenter,

        // IF NEEDS CLONE OF BUSINESS REQUIREMENTS
        // businessRequirement: bizData[0]?.businessRequirement

        // FOR DIFFERENT BUSINESS REQUIREMENTS FOR MULTI CITY
        businessRequirement: JSON.parse(
          JSON.stringify(bizData[0]?.businessRequirement),
        ).map((item) => {
          if (item.label !== "per_diem") {
            return { ...item, selected: "", isChecked: false };
          } else {
            return { ...item };
          }
        }),
      },
    ]);
    setErrors([
      ...errors,
      { ...JSON.parse(JSON.stringify(FORM_ERROR_INITIALIZATION)) },
    ]);
  };

  const fetchPerDiemData = async (
    startDate,
    endDate,
    profileData,
    shouldSetValues = true,
    resetDates = false,
  ) => {
    let leaveError = validatePerdiem(
      { startDate, endDate },
      setApplyLeaveErrors,
    );
    if (leaveError) {
      setErrorModal({
        open: true,
        title: "Invalid leave details",
        message: "Please review your selected dates.",
      });
      // toast.error("Invalid leave details. Please review your selected dates.");
      return;
    }
    let [isMixMI, isDomesticTrip] = validateMixDomesticInternational(
      bizData,
      profileData,
    );

    if (isMixMI) {
      // toast.error(
      //   "You can’t mix domestic and international trips in a single request. Kindly raise separate requests for each.",
      // );
      setErrorModal({
        open: true,
        title: "Book Trips Separately",
        message: "Domestic & international trips must be booked separately.",
      });
      return;
    }
    setLoader(true);
    try {
      const countryOfCompany = profileData?.countryOfCompany;
      let res = await getPerdiemData({
        startDate: dayjs(startDate).format("YYYY-MM-DD"),
        endDate: dayjs(endDate).subtract(1, "day").format("YYYY-MM-DD"),
        grade: profileData?.grade,
        countryOfCompany: countryOfCompany,
        companyCode: profileData?.companyCode,
        isDomesticTrip: isDomesticTrip ? "true" : "false",
      });
      setPDTripType(isDomesticTrip ? "domestic" : "international");
      setPerDiemData(res?.data?.data);
      if (shouldSetValues) {
        let bizTripClone = [...bizData];
        bizTripClone.map((tripItem, index) => {
          tripItem["businessRequirement"].map((item) => {
            if (item.label === "per_diem") {
              item["selected"] = res?.data?.data?.totalAllowance || 0;
            } else {
              item["selected"] = item["selected"];
            }
            return tripItem;
          });
          if (resetDates) {
            tripItem.departureDate = "";
            tripItem.returnDate = "";
          }
          return tripItem;
        });

        setBizData(bizTripClone);
      }
    } catch (err) {
      // toast.error(err?.message);
      setErrorModal({
        open: true,
        message: err?.message,
        title: "Oops!",
      });
    } finally {
      setLoader(false);
    }
  };

  const handleFormChange = async (e) => {
    let { value, name } = e.target;
    // console.log(value, name);

    let errorClone = [...errors];

    let index = activeTripType === "Multi City" ? activeMCIndex : 0;
    let bizDataClone = [...bizData];

    // console.log(settingsData?.some((i) => i.key === name));
    // console.log(settingsData);

    if (settingsData?.some((i) => i.key === name)) {
      if (name === "per_diem") {
        if (!value) {
          setPerDiemData({});
          setPDTripType("");
        }
        if (value && applyLeaveData?.startDate && applyLeaveData?.endDate) {
          fetchPerDiemData(
            applyLeaveData?.startDate,
            applyLeaveData?.endDate,
            profileData,
            true,
          );
        }
        bizDataClone.map((item, i) => {
          item["businessRequirement"].map((item) => {
            if (item.label === name) {
              item.isChecked = value;
              item.selected = 0;
            }
            return item;
          });
        });
      } else {
        bizDataClone[index].businessRequirement = bizDataClone[
          index
        ].businessRequirement.map((item) => {
          if (item.label === name) {
            if (typeof value === "boolean") {
              item.isChecked = value;
              if (!value) {
                item.selected = "";
              }
            } else {
              item.selected = value;
            }
          }
          return item;
        });
      }
      errorClone = errorClone.map((obj) => {
        if (obj.businessRequirement) {
          obj.businessRequirement[name] = "";
          // obj["travelClass"] = "";
        }
        return obj;
      });
    } else {
      if (name === "costBorneBy") {
        setLoader(true);
        try {
          let res = await getCostCenter(value);
          let costCenterList = res?.data?.data.map((cl) => ({
            name: cl.description,
            id: cl.profit_center,
          }));
          setCostCenterList(costCenterList);
          setProjects([]);
        } catch (err) {
        } finally {
          setLoader(false);
        }

        bizDataClone.forEach((item, i) => {
          item[name] = value;
          item["costCenter"] = "";
          item["projectId"] = "";
          errorClone[i][name] = "";
        });
      } else if (name === "costCenter") {
        let res;
        if (value) {
          setLoader(true);
          try {
            res = await getProjectId(value);

            let projectList = res?.data?.data.map((pl) => ({
              name: `${pl.Project_Definition}`,
              id: pl.Project_Definition,
            }));

            setProjects(projectList);
          } catch (err) {
          } finally {
            setLoader(false);
          }
        } else {
          setProjects([]);
        }

        bizDataClone.forEach((item, i) => {
          item[name] = value;
          item["projectId"] = res?.data?.data[0]?.Project_Definition ?? "";
          errorClone[i][name] = "";
        });
      } else if (name === "projectId") {
        bizDataClone.forEach((item, i) => {
          item[name] = value;
          errorClone[i][name] = "";
        });
      } else {
        bizDataClone[index][name] = value;
        errorClone[index][name] = "";
      }
    }
    setBizData(bizDataClone);
    setErrors(errorClone);
  };

  const handleTimeRangeSelect = (time, journeyType) => {
    let index = activeTripType === "Multi City" ? activeMCIndex : 0;
    let bizDataClone = [...bizData];

    if (journeyType === "departure") {
      bizDataClone[index]["departureTime"] = time;
    }
    if (journeyType === "return") {
      bizDataClone[index]["returnTime"] = time;
    }
    setBizData(bizDataClone);

    let errorClone = [...errors];
    errorClone[index]["time"] = "";
    setErrors(errorClone);
  };

  const handleCheckAirlines = (val, label) => {
    let index = activeTripType === "Multi City" ? activeMCIndex : 0;
    let bizDataClone = [...bizData];
    const updatedAirlines = [...bizDataClone[index].preferredAirlines];
    const numSelected = updatedAirlines.filter(
      (airline) => airline.selected,
    ).length;
    if (val && numSelected === 5) {
      return;
    }
    let airlineindex = updatedAirlines.findIndex((i) => i.label === label);
    updatedAirlines[airlineindex].selected = val;
    bizDataClone[index].preferredAirlines = JSON.parse(
      JSON.stringify([...updatedAirlines]),
    );
    setBizData(bizDataClone);
  };

  const handleBizTripDateSelection = (start, end) => {
    let departureDate = start ? dayjs(start).format("YYYY/MM/DD") : "";
    let returnDate = start ? dayjs(end).format("YYYY/MM/DD") : "";

    let index = activeTripType === "Multi City" ? activeMCIndex : 0;
    let bizDataClone = [...bizData];
    bizDataClone[index]["departureDate"] = departureDate;
    bizDataClone[index]["returnDate"] = returnDate;
    setBizData(bizDataClone);

    let errorClone = [...errors];
    errorClone[index]["date"] = "";
    setErrors(errorClone);
  };

  const handleLeaveFormChange = (e) => {
    setApplyLeaveErrors({
      ...applyLeaveFormErrors,
      [e.target.name]: "",
    });
    setApplyLeave({ ...applyLeaveData, [e.target.name]: e.target.value });
    if (e.target.name === "endDate" || e.target.name === "startDate") {
      setBizData((prev) =>
        prev.map((item) => ({
          ...item,
          departureDate: "",
          returnDate: "",
        })),
      );
    }
    if (
      e.target.name === "endDate" &&
      applyLeaveData?.startDate &&
      bizData?.[0]?.businessRequirement.some(
        (item) => item.label === "per_diem" && item.isChecked,
      )
    ) {
      fetchPerDiemData(
        applyLeaveData?.startDate,
        e.target.value,
        profileData,
        true,
        true,
      );
    } else if (
      e.target.name === "startDate" &&
      applyLeaveData?.endDate &&
      bizData?.[0]?.businessRequirement?.some(
        (item) => item.label === "per_diem" && item.isChecked,
      )
    ) {
      fetchPerDiemData(
        e.target.value,
        applyLeaveData?.endDate,
        profileData,
        true,
        true,
      );
    }
  };

  function hasSameDepartureAndReturn(trips) {
    return trips.some(
      (trip) =>
        trip.departureDate === trip.returnDate &&
        trip.departureTime === trip.returnTime,
    );
  }

  function isPerDiemChecked(travelRequest) {
    if (!Array.isArray(travelRequest)) return false;

    return travelRequest.some(
      (item) =>
        Array.isArray(item.businessRequirement) &&
        item.businessRequirement.some(
          (req) => req.label === "per_diem" && req.isChecked === true,
        ),
    );
  }

  const handleSubmit = (from) => {
    // if (perDiemData?.totalAllowance) {
    let [isMixMI, isDomesticTrip] = validateMixDomesticInternational(
      bizData,
      profileData,
    );

    if (isMixMI) {
      // toast.error(
      //   "You can’t mix domestic and international trips in a single request. Kindly raise separate requests for each.",
      // );
      setErrorModal({
        open: true,
        title: "Book Trips Separately",
        message: "Domestic & international trips must be booked separately.",
      });
      return;
    }
    if (perDiemTripType !== "") {
      if (isDomesticTrip && perDiemTripType !== "domestic") {
        setErrorModal({
          open: true,
          title: "Trip type changed",
          message: "Please review and reselect per diem.",
        });

        return;
      }
      if (!isDomesticTrip && perDiemTripType !== "international") {
        setErrorModal({
          open: true,
          title: "Trip type changed",
          message: "Please review and reselect per diem.",
        });

        return;
      }
    }
    // }

    if (activeTripType === "Multi City" && bizData.length < 2) {
      // toast.error(
      //   "Select two or more cities for multi-city travel, or switch to One Way/Round Trip.",
      // );
      setErrorModal({
        open: true,
        title: "Action Required",
        message:
          "Select 2+ cities for multi-city, or choose One Way/Round Trip.",
      });
    } else {
      let error = validateBizTrip(bizData, setErrors);
      let leaveError = validateLeaveRequest(
        applyLeaveData,
        setApplyLeaveErrors,
      );
      let leaveAndDataError =
        activeTripType === "Round Trip"
          ? validateLeaveWithData(bizData, applyLeaveData, setErrors)
          : false;
      if (!error && !leaveError && !leaveAndDataError) {
        if (from === "popup") {
          setTimeModal(false);
          setPerDiemPopup(false);
          setValidFrom(true);
        } else {
          const isSameDepartureAndReturnDateTime =
            hasSameDepartureAndReturn(bizData);
          const isPerDiemSelected = isPerDiemChecked(bizData);
          if (isSameDepartureAndReturnDateTime || !isPerDiemSelected) {
            console.log("IF");
            console.log(isSameDepartureAndReturnDateTime);
            console.log(!isPerDiemSelected);

            setTimeModal(isSameDepartureAndReturnDateTime);
            setPerDiemPopup(!isPerDiemSelected);
          } else {
            setTimeModal(false);
            setPerDiemPopup(false);
            setValidFrom(true);
          }
        }
      } else {
        setErrorModal({
          open: true,
          title: "Form has errors.",
          message: "Please review and fix before submitting.",
        });
        // toast.error(
        //   "There are errors in the form. Please review and fix them before submitting.",
        // );
      }
    }
  };

  const handleFinalSubmit = async () => {
    let [isMixMI, isDomesticTrip] = validateMixDomesticInternational(
      bizData,
      profileData,
    );
    setLoader(true);
    let postObj = getBizTripPayload(
      bizData,
      activeTripType,
      profileData,
      applyLeaveData,
      passportData,
      perDiemData,
      companyList,
      comment,
      privilegeCard,
      isDomesticTrip,
      costCenterList,
    );
    console.log(postObj);

    try {
      let res;
      if (id) {
        res = await updateBizBooking(postObj, id);
      } else {
        res = await addBizBooking(postObj);
      }
      if (id) {
        setBookingId(res?.data?.requestId || res?.data?.data?.requestId);
      } else {
        setBookingId(res?.data?.requestId || res?.data?.data?.requestId);
      }
    } catch (err) {
      // toast.error(err?.message);
      setErrorModal({
        open: true,
        message: err?.message,
        title: "Oops!",
      });
    } finally {
      setLoader(false);
    }
  };

  const handleLoadApprovers = async (id) => {
    console.log(id);
    let res = await getApproversList(id);
    console.log(res?.data?.data[0]);
    setApproversList({ ...res?.data?.data[0], id });
  };

  const handleDeleteCity = (index) => {
    if (activeTripType === "Multi City") {
      setBizData((prev) => prev.filter((_, i) => i !== index));
      setErrors((prev) => prev.filter((_, i) => i !== index));

      setActiveMCIndex((prevIndex) => {
        if (prevIndex === index) return "";
        if (prevIndex > index) return prevIndex - 1;
        return prevIndex;
      });
    } else {
      // toast.error("Delete is only available in Multi-City mode.");
      setErrorModal({
        open: true,
        message: "Delete is only available in Multi-City mode.",
        title: "Oops!",
      });
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoader(true);
    try {
      const response = await uploadLeaveAttachment(file);
      const fileResponse = await uploadDocuments(file);
      if (response?.status === 200 && fileResponse?.status === 200) {
        setLoader(false);
        const str = response?.data?.data.key;
        const id = str.split("attachmentId=")[1];
        setApplyLeave({
          ...applyLeaveData,
          attachmentId: id || "",
          attachmentUrl: fileResponse?.data?.files[0]?.viewUrl || "",
        });
        setLeaveFile(fileResponse);
      }
    } catch (err) {
      console.error(err);
      setLoader(false);
    }
  };

  const handleDeleteAttachment = () => {
    setLeaveFile("");
    setApplyLeave({ ...applyLeaveData, attachmentId: "", attachmentUrl: "" });
  };

  const handleDownloadLeaveAttachment = () => {
    if (!leaveFile) {
      console.error("No file link available");
      return;
    }

    const link = document.createElement("a");
    link.href = leaveFile;
    link.download = applyLeaveData?.attachmentId || leaveFile || "attachment";
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  };

  return (
    <Container>
      {!isValidForm ? (
        <>
          <LeftSection>
            <BizTripHomePassengerDetails name={profileData?.formalName} />
            <DetailsContainer>
              <UpcomingLeaves
                data={upcomingLeaves}
                onLeaveSelect={() => {}}
                onLoadApprovers={handleLoadApprovers}
                approversList={approversList}
              />
              <UpcomingTrips data={upcomingTrips} />
            </DetailsContainer>
          </LeftSection>
          <RightSection>
            <BookingContainer>
              <Title>Business Trip Booking for {profileData?.firstName}</Title>
              <LeaveForm
                onLeaveFormChange={handleLeaveFormChange}
                applyLeaveData={applyLeaveData}
                errors={applyLeaveFormErrors}
                onFileUpload={handleFileUpload}
                file={leaveFile}
                onDeleteFile={handleDeleteAttachment}
                onDownloadFile={handleDownloadLeaveAttachment}
              />
              <BizTripTypes
                activeLabel={activeTripType}
                onTripTypeSelect={handleTravelTypeChange}
              />
              <BizTripForm
                errors={errors}
                data={bizData}
                activeTripType={activeTripType}
                flightTypes={FLIGHT_TYPE}
                payType={PAYMENT_TYPE}
                travelType={TRAVEL_TYPE}
                selectedLeave={applyLeaveData}
                companyList={companyList}
                costCenterList={costCenterList}
                projectList={projectList}
                onFlightTypeSelect={handleFormChange}
                onTravelTypeSelect={handleFormChange}
                onPayTypeSelect={handleFormChange}
                onTripTypeChange={handleFormChange}
                onAddCity={handleAddCity}
                onSelectActiveIndex={(val) =>
                  setActiveMCIndex(activeMCIndex === val ? "" : val)
                }
                activeMCIndex={activeMCIndex}
                onAirportSelect={handleFormChange}
                onTimeRangeSelect={handleTimeRangeSelect}
                onCheckAirlines={handleCheckAirlines}
                onDateSelection={handleBizTripDateSelection}
                onTravelReqChange={handleFormChange}
                onCompanySelected={handleFormChange}
                onPrivilegeChange={(e) => setPrivilegeCard(e.target.value)}
                onDeleteCity={handleDeleteCity}
                privilegeCard={privilegeCard}
                perDiemData={perDiemData}
                settingsData={settingsData}
              />
              <div style={{ marginTop: "16px", fontSize: "14px" }}>
                Any special requests?
              </div>
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                rows={4}
                placeholder="Example: Need a driving license, I have an approved exception for travelling on business class"
                style={{
                  width: "100%",
                  borderRadius: "16px",
                  marginTop: "4px",
                  padding: "16px",
                  fontFamily: "inherit",
                  boxSizing: "border-box",
                }}
              ></textarea>
              <SubmitBizTripRequestButton onSubmit={handleSubmit} />
            </BookingContainer>
          </RightSection>
        </>
      ) : (
        <ConfirmBookingDialog
          onBackClick={() => setValidFrom(false)}
          onSubmit={handleFinalSubmit}
          leaveDetails={applyLeaveData}
          isBusinessTrip={true}
          privilegeCard={privilegeCard}
          bookingComments={comment}
        />
      )}
      {bookingId && (
        <SuccessBookingDialog
          bizData={bizData}
          leaveDetails={applyLeaveData}
          bookingId={bookingId}
        />
      )}
      {(timeModal || perDiemPopup) && (
        <ConfirmPopup
          onClose={() => {
            setTimeModal(false);
            setPerDiemPopup(false);
          }}
          onConfirm={() => handleSubmit("popup")}
          timeModal={timeModal}
          perDiemPopup={perDiemPopup}
        />
      )}
      {errorModal?.open && (
        <ErrorModal
          onButtonClick={() =>
            setErrorModal({
              open: false,
              title: "",
              message: "",
            })
          }
          buttonText="Close"
          subheaderText={errorModal?.message}
          headerText={errorModal?.title}
          icon={require("../../assets/images/subtract.png")}
        />
      )}
    </Container>
  );
};

export default BusinessTripHome;
